export const categories = [
  {
    slug: "gongju-tuijian",
    name: "工具推荐",
    icon: "ri-tools-line",
    description: "精选高效实用的在线工具，提升工作与生活效率",
    color: "bg-emerald-100 text-emerald-700",
    count: 28,
  },
  {
    slug: "ziyuan-xiazai",
    name: "资源下载",
    icon: "ri-download-cloud-2-line",
    description: "优质素材、模板、软件资源一网打尽",
    color: "bg-amber-100 text-amber-700",
    count: 35,
  },
  {
    slug: "sheji-linggan",
    name: "设计灵感",
    icon: "ri-palette-line",
    description: "探索全球优秀设计作品，激发无限创意",
    color: "bg-rose-100 text-rose-700",
    count: 22,
  },
  {
    slug: "xuexi-pingtai",
    name: "学习平台",
    icon: "ri-book-open-line",
    description: "优质在线学习资源，随时随地提升技能",
    color: "bg-sky-100 text-sky-700",
    count: 30,
  },
  {
    slug: "xinwen-zixun",
    name: "新闻资讯",
    icon: "ri-newspaper-line",
    description: "实时热点新闻聚合，掌握最新资讯动态",
    color: "bg-indigo-100 text-indigo-700",
    count: 18,
  },
  {
    slug: "shenghuo-yule",
    name: "生活娱乐",
    icon: "ri-movie-2-line",
    description: "影音、音乐、阅读，丰富你的休闲时光",
    color: "bg-orange-100 text-orange-700",
    count: 25,
  },
  {
    slug: "kaifa-biancheng",
    name: "开发编程",
    icon: "ri-code-box-line",
    description: "程序员必备的开发工具与学习资源",
    color: "bg-teal-100 text-teal-700",
    count: 40,
  },
  {
    slug: "bangong-xietong",
    name: "办公协同",
    icon: "ri-briefcase-line",
    description: "高效办公与团队协作工具合集",
    color: "bg-violet-100 text-violet-700",
    count: 20,
  },
];

export const getCategoryBySlug = (slug: string) => {
  return categories.find((c) => c.slug === slug) || null;
};